module.exports = __webpack_public_path__ + "static/media/Icon-filter-white.aa345a93.png";